import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../lib/api';
import { useAuth } from './AuthContext';

const BillingContext = createContext(null);

export const BillingProvider = ({ children }) => {
  const { user } = useAuth();
  const [billing, setBilling] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchStatus = useCallback(async () => {
    try {
      const res = await api.get('/billing/status');
      setBilling(res.data);
      return res.data;
    } catch (e) {
      console.error('Billing status error:', e);
      // Fail-open on status errors so a billing hiccup never locks the app
      setBilling({ access: true, subscribed: false, trial_active: true, trial_days_left: 0 });
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const refresh = useCallback(async () => {
    const res = await api.post('/billing/refresh');
    setBilling(res.data);
    return res.data;
  }, []);

  useEffect(() => {
    if (user) {
      setLoading(true);
      fetchStatus();
    }
  }, [user, fetchStatus]);

  return (
    <BillingContext.Provider value={{ billing, loading, refresh, fetchStatus }}>
      {children}
    </BillingContext.Provider>
  );
};

export const useBilling = () => {
  const ctx = useContext(BillingContext);
  if (!ctx) throw new Error('useBilling must be used within BillingProvider');
  return ctx;
};
